import type { IconSvgObject } from './types';

const ChartBubble02Icon: IconSvgObject = [
  ["circle", { cx: "5", cy: "7", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "8", cy: "18", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "17", cy: "7", r: "5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default ChartBubble02Icon;
